<div class="card report-definition-card p-text-center p-p-0">
    <div [id]="this.ReportImageHtmlWrapperId" class="report-image-fullwidth report-image"
        (click)="viewReportDefinition(this.Report)">
        <img [id]="this.ReportImageHtmlId" src="/assets/layout/images/loader.gif" />
    </div>
    <div class="p-pt-3 p-px-3 p-pb-0">
        <p *ngIf="this.Report.ReportType.id==1" class="card-title">GEN: {{this.Report.Name}}</p>
        <p *ngIf="this.Report.ReportType.id==2" class="card-title">{{this.Report.Name}}</p>
        <p>{{this.Report.Description}}</p>
        <div class="p-text-center">
            <button style="font-size: 16px" pButton (click)="viewReportDefinition(this.Report)" 
                pTooltip="Edit" tooltipPosition="top"  icon="ui-button-icon-left ui-clickable ui-icon-edit" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
            <button style="font-size: 16px" *ngIf="this.showPreviewLink" pButton  icon="ui-button-icon-left ui-clickable pi pi-external-link"
                (click)="previewReport(this.Report)" pTooltip="Preview" tooltipPosition="top" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
            <button style="font-size: 16px" pButton (click)="duplicateReportDefinition(this.Report)"  icon="ui-button-icon-left ui-clickable pi pi-copy"
                pTooltip="Duplicate" tooltipPosition="top" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
                <button style="font-size: 16px" pButton (click)="copyToCompany(this.Report)"  icon="ui-button-icon-left ui-clickable pi pi-copy"
                pTooltip="Copy to Company..." tooltipPosition="top" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
                <button style="font-size: 16px" pButton (click)="deleteReportDefinition(this.Report)"  icon="ui-button-icon-left ui-clickable ui-icon-delete"
                pTooltip="Delete" tooltipPosition="top" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
                
        </div>
    </div>
    <p-dialog class="ui-fluid" header="Copy report to Company..." [(visible)]="displayCopyToCompany" *ngIf="displayCopyToCompany"
    [style]="{width: '40%', height: '40%'}" appendTo="body">
    <br>
    <div  class="ui-g form-group">
        <div class="ui-g-12">
            <div class="p-float-label">
                <p-dropdown class="dropdown-reportDefinitions" (onChange)="dataChanged($event)" [options]="this.companies" optionLabel="name" [autoDisplayFirst]=false
            dataKey="id" ></p-dropdown>
            <label>Company code</label>
            </div>
        </div>
    </div>
    <div  class="ui-g-12">
        <button label="Copy" pButton icon="pi pi-check" (click)="copyToCompanyReportClick()"
            style="margin-right: 0.5em"></button>
        <button label="Cancel" pButton icon="pi pi-times"
            (click)="displayCopyToCompany=false;"></button>
    </div>
    
</p-dialog>
</div>
